<form class="user-form page" [formGroup]="form" [ngClass]="{ 'submit-attempted': submitAttempted }">
  @if (!isLoading && !isSubmitLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <h4>{{ 'pages.user.titleEdit' | translate }} - {{ user?.fullName }}</h4>
      <div class="actions d-flex flex-wrap m-0">
        @if (form.dirty) {
          <button class="primary add-btn" type="button" (click)="submit()">
            {{ 'pages.user.submitEdit' | translate }}
          </button>
          <button class="secondary back-btn" type="button" (click)="cancelChanges()">
            {{ 'pages.user.back' | translate }}
          </button>
        }
        <button class="secondary back-btn" type="button" (click)="back(false)">
          {{ 'pages.user.backToList' | translate }}
        </button>
      </div>
    </div>
    @if (!isMyProfileOnly) {
    <div class="section">
      <p class="section-header">{{ 'pages.user.baseInfo' | translate }}</p>
      <div class="row">
        <div class="column">
          <p class="form-label lna">
            {{ 'pages.user.nameSurname' | translate }}
          </p>
          <p>{{ user?.fullName }}</p>
        </div>
        <div class="column">
          <p class="form-label lna">{{ 'pages.user.email' | translate }}</p>
          <p>{{ user?.email }}</p>
        </div>
      </div>
      <div class="row status-row">
        <p class="form-label lna status-label"><span>{{ 'pages.user.status' | translate }}</span> <app-tooltip [marginBottom]="false" text="userStatus" [position]="'top-right'"></app-tooltip></p>
        <div class="status-radio">
          <div class="radio-wrapper">
            <input
              id="active"
              [checked]="form.get('activationStatus')?.value === 'Active'"
              [attr.disabled]="!hasEditUserClaim() ? true : null"
              type="radio"
              name="activationStatus"
              formControlName="activationStatus"
              value="Active" />
            <label for="active">
              {{ 'pages.user.activationStatus.Active' | translate }}
              {{
                user?.activationStatus === 'Active'
                  ? '(' + ('pages.user.statusFrom' | translate) + formatDatetime(user?.activationStatusChangedOn || '') + ')'
                  : ''
              }}
            </label>
          </div>
          <div class="radio-wrapper">
            <input
              id="blocked"
              [checked]="form.get('activationStatus')?.value === 'Blocked'"
              [attr.disabled]="!hasEditUserClaim() ? true : null"
              type="radio"
              name="activationStatus"
              formControlName="activationStatus"
              value="Blocked" />
            <label for="inactive">
              {{ 'pages.user.activationStatus.Blocked' | translate }}
              {{
                user?.activationStatus === 'Blocked'
                  ? '(' + ('pages.user.statusFrom' | translate) + formatDatetime(user?.activationStatusChangedOn || '') + ')'
                  : ''
              }}
            </label>
          </div>
          <div class="radio-wrapper">
            <input
              id="new"
              [checked]="form.get('activationStatus')?.value === 'New'"
              [attr.disabled]="user?.activationStatus !== 'New' ? true : null"
              type="radio"
              name="activationStatus"
              formControlName="activationStatus"
              value="New" />
            <label for="inactive">
              {{ 'pages.user.activationStatus.New' | translate }}
              {{
                user?.activationStatus === 'New'
                  ? '(' + ('pages.user.statusFrom' | translate) + formatDatetime(user?.activationStatusChangedOn || '') + ')'
                  : ''
              }}
            </label>
          </div>
        </div>
      </div>
    </div>
    }
    <div class="section absences">
      <div class="title-row">
        <div class="table-header-wrapper">
          <h6>{{ 'pages.user.absenceTitle' | translate }}</h6>
          <app-tooltip text="absenceTitle" [marginBottom]="false" [position]="'top-right'"></app-tooltip>
        </div>

        @if (canEditAbsences) {
          <button class="secondary" (click)="addAbsence()" type="button">
            <img src="assets/images/add-icon.svg" alt="add icon" />
            {{ 'pages.user.addAbsence' | translate }}
          </button>
        }
      </div>
      <div class="labels-wrapper">
       <p>{{ 'pages.user.absenceStatus' |translate }}</p>
        <p class="table-header-wrapper">
          <span>{{ 'pages.user.absencePeriod' | translate }}</span>
          @if (canEditAbsences) {
            <span class="required-field">*</span>
          }
          <app-tooltip text="absencePeriod" [marginBottom]="false"></app-tooltip>
        </p>
        <p class="table-header-wrapper">
          <span>{{ 'pages.user.substitute' | translate }}</span>
          @if (canEditAbsences) {
            <span class="required-field">*</span>
          }
          <app-tooltip text="absenceSubstitute" [marginBottom]="false"></app-tooltip>
        </p>
        <p>{{ 'pages.user.absenceCreatedBy' | translate }}</p>
      </div>
      <div formArrayName="absences">
        @for (absence of absenceEntries.controls; track absence; let parentIndex = $index) {
          @if (!isDateBeforeToday(absence.get('periodEnd')?.value) || isUnmodifiedActive(absence.value)) {
            <div class="absence-row" [formGroupName]="$index">
              <div class="absence-value">
                <div class="absence-status" [ngClass]="getAbsenceStatus($index)">
                  {{ getAbsenceStatus($index) === 'empty' ? '-' : ('pages.user.absenceStatuses.' + getAbsenceStatus($index) | translate) }}
                </div>
              </div>
              <div class="absence-value">
                @if (canEditAbsences) {
                  <app-date-range-picker
                    [restrictFromDate]="getAbsenceStatus($index) === 'active' || isUnmodifiedActive(absence.value)"
                    [from]="absence.get('periodStart')?.value"
                    [to]="absence.get('periodEnd')?.value"
                    [disabledDates]="getDisabledDates($index)"
                    [maxDate]="getMaxDateAtIndex($index)"
                    [minDateYesterday]="getAbsenceStatus($index) === 'active'"
                    [todayAvailable]="true"
                    [disabled]="!canEditAbsences"
                    [ngClass]="{
                      error: shouldRenderError('absences.periodStart', $index) || shouldRenderError('absences.periodEnd', $index)
                    }"
                    (rangeChanged)="absenceRangeChanged($event, $index)" />
                  <div class="error-wrapper">
                    @if (shouldRenderError('absences.periodStart', $index)) {
                      @if (absence.get('periodStart')?.errors?.['required']) {
                        <small class="error-message">
                          {{ 'components.form.errorRequired' | translate }}
                        </small>
                      }
                    }
                  </div>
                } @else {
                  <p>
                    {{ formatDatetime(absence.get('periodStart')?.value) }} -
                    {{ formatDatetime(absence.get('periodEnd')?.value) }}
                  </p>
                }
              </div>
              <div class="absence-value">
                @if (canEditAbsences) {
                  <select
                    [ngClass]="{
                      error: shouldRenderError('absences.substituteUserId', $index)
                    }"
                    formControlName="substituteUserId">
                    <option [value]="null" disabled>
                      {{ 'pages.user.chooseSubstitute' | translate }}
                    </option>
                    @for (option of substituteOptions; track option.value) {
                      <option [value]="option.value">{{ option.label }}</option>
                    }
                  </select>
                  <div class="error-wrapper">
                    @if (shouldRenderError('absences.substituteUserId', parentIndex)) {
                      @if (absence.get('substituteUserId')?.errors?.['required']) {
                        <small class="error-message">
                          {{ 'components.form.errorRequired' | translate }}
                        </small>
                      }
                    }
                  </div>
                } @else {
                  <p>
                    {{ getUserFullName(absence.get('substituteUserId')?.value) }}
                  </p>
                }
              </div>
              <div class="absence-value last-row space-between">
                <p>
                  {{ getUserFullName(absence.get('createdByUserId')?.value) }}
                </p>
                @if (canEditAbsences) {
                  <button class="action-link" (click)="deleteAbsence($index)">
                    <img src="assets/images/delete-icon.svg" alt="delete" />
                    {{ 'pages.user.deleteAbsence' | translate }}
                  </button>
                }
              </div>
            </div>
          }
        }
        <div
          class="historical-toggle"
          [ngClass]="{ open: !isHistoricalAbsencesCollapsed }"
          [attr.aria-expanded]="!isHistoricalAbsencesCollapsed"
          (click)="isHistoricalAbsencesCollapsed = !isHistoricalAbsencesCollapsed"
          (keydown.enter)="isHistoricalAbsencesCollapsed = !isHistoricalAbsencesCollapsed"
          tabindex="1"
          aria-controls="collapse">
          <img [ngClass]="{ chevron: true, open: !isHistoricalAbsencesCollapsed }" src="assets/images/chevron-icon.svg" alt="arrow" />
          <h6>{{ 'pages.user.historicalAbsence' | translate }}</h6>
        </div>
        <div class="historical-entries" [ngbCollapse]="isHistoricalAbsencesCollapsed">
          @for (originalAbsence of originalAbsences; track originalAbsence) {
            @if (isDateBeforeToday(originalAbsence.periodEnd || '')) {
              <div class="absence-row" [formGroupName]="$index">
                <div class="absence-value">
                  <div class="absence-status historical">
                    {{ 'pages.user.absenceStatuses.historical' | translate }}
                  </div>
                </div>
                <p>
                  {{ formatDatetime(originalAbsence.periodStart) }} -
                  {{ formatDatetime(originalAbsence.periodEnd) }}
                </p>
                <p>{{ originalAbsence.substituteUser.firstName }} {{ originalAbsence.substituteUser.lastName }}</p>
                <p>{{ originalAbsence.createdByUser.firstName }} {{ originalAbsence.createdByUser.lastName }}</p>
              </div>
            }
          }
          @if (!hasHistoricalAbsences()) {
            <p class="no-absences">
              {{ 'pages.user.noHistoricalAbsences' | translate }}
            </p>
          }
        </div>
      </div>
    </div>
    @if (!isMyProfileOnly) {
    <div class="section" formArrayName="roles">
      <div class="title-row">
                <div class="table-header-wrapper">
                  <h6>{{ 'pages.user.roleTitle' | translate }}</h6>
                  <app-tooltip text="roleTitle" [marginBottom]="false" [position]="'top-right'"></app-tooltip>
                </div>
        <button
          class="secondary"
          [policyType]="POLICY_TYPE_ROLE"
          [claimType]="CLAIM_TYPES['create']"
          (click)="addRole()"
          type="button"
          appPermission>
          <img src="assets/images/add-icon.svg" alt="add role" />
          {{ 'pages.user.addRole' | translate }}
        </button>
      </div>
      @for (role of roleEntries.controls; track role; let parentIndex = $index) {
        @if (role.get('roleId')?.value === getSystemUserId()) {
          <div class="system-role disabled">
            <p>{{ getRoleName(role.get('roleId')?.value) }}</p>
          </div>
        }
        @if (!isSystemRole(role.get('roleId')?.value)) {
          <div class="structural-role role" [formGroupName]="$index">
            <div class="toggle">
              <div class="toggle-left">
                <div
                  class="toggle-left-wrapper"
                  [attr.aria-expanded]="!isStructuralUnitsCollapsed[parentIndex]"
                  (click)="toggleStructuralUnitsCollapse(parentIndex)"
                  (keydown.enter)="toggleStructuralUnitsCollapse(parentIndex)"
                  tabindex="1"
                  aria-controls="collapse">
                  <img
                    [ngClass]="{ chevron: true, open: !isStructuralUnitsCollapsed[parentIndex] }"
                    src="assets/images/chevron-icon.svg"
                    alt="arrow" />
                </div>
                @if (hasEditRoleClaim()) {
                  <select
                    [ngClass]="{
                      error: shouldRenderError('roles.roleId', parentIndex)
                    }"
                    formControlName="roleId">
                    <option [ngValue]="''" [selected]="roleEntries.at($index).get('roleId')?.value === ''" disabled>
                      {{ 'pages.user.chooseRole' | translate }}
                    </option>
                    @for (roleOption of allRoles; track roleOption) {
                      @if (roleOption.name !== 'SystemUser') {
                        <option
                          [ngValue]="roleOption.id"
                          [selected]="roleEntries.at(parentIndex).get('roleId')?.value === roleOption.id"
                          [disabled]="isRoleOptionDisabled(roleOption.id!)">
                          {{ roleOption.name }}
                        </option>
                      }
                    }
                  </select>
                } @else {
                  <p class="role-text">{{ getRoleName(role.get('roleId')?.value) }}</p>
                }
                <div class="error-wrapper-relative">
                  @if (shouldRenderError('roles.roleId', parentIndex)) {
                    @if (role.get('roleId')?.errors?.['required']) {
                      <small class="error-message">
                        {{ 'components.form.errorRequired' | translate }}
                      </small>
                    }
                  }
                </div>
              </div>
              <div class="actions">
                <button
                  class="action-link"
                  [policyType]="POLICY_TYPE_ROLE"
                  [claimType]="CLAIM_TYPES['update']"
                  (click)="deleteRole(parentIndex)"
                  appPermission>
                  <img src="assets/images/delete-icon.svg" alt="delete" />
                  {{ 'pages.user.deleteAbsence' | translate }}
                </button>
                @if (role.get('roleId')?.value && role.get('roleId')?.value !== '') {
                  <button
                    class="action-link"
                    [policyType]="POLICY_TYPE_ROLE"
                    [claimType]="CLAIM_TYPES['create']"
                    (click)="addStructuralRole($index)"
                    appPermission>
                    <img src="assets/images/add-icon.svg" alt="add Structura unitl" />
                    {{ 'pages.user.addStructuralRole' | translate }}
                  </button>
                }
              </div>
            </div>
            <div class="structural-units" [ngbCollapse]="!isStructuralUnitsCollapsed[parentIndex]">
              @for (structuralRole of role.get('structuralUnitIds')?.value; track structuralIndex; let structuralIndex = $index) {
                <div class="structural-select">
                  <div class="input-wrapper">
                    @if (hasEditRoleClaim()) {
                      <select
                        [ngClass]="{
                          error:
                            shouldRenderError('roles.structuralUnitIds', parentIndex) &&
                            getStructuralUnitIdAtIndex(parentIndex, structuralIndex) === ''
                        }"
                        (change)="handleStructuralUnitChange($event, parentIndex, structuralIndex)">
                        <option
                          [value]="''"
                          [selected]="roleEntries.at(parentIndex).get('structuralUnitIds')?.value?.at(structuralIndex) === ''"
                          disabled>
                          {{ 'pages.user.chooseStructuralUnit' | translate }}
                        </option>
                        @for (option of structuralUnitOptions; track option) {
                          <option
                            [value]="option.id"
                            [selected]="roleEntries.at(parentIndex).get('structuralUnitIds')?.value?.at(structuralIndex) === option.id"
                            [disabled]="isUnitOptionDisabled(parentIndex, option.id!)">
                            {{ option.name }}
                          </option>
                        }
                      </select>
                    } @else {
                      <p class="role-text">{{ getStructuralUnitName(role.get('structuralUnitIds')?.value?.at(structuralIndex) || '') }}</p>
                    }
                    <div class="error-wrapper-relative">
                      @if (
                        shouldRenderError('roles.structuralUnitIds', parentIndex) &&
                        getStructuralUnitIdAtIndex(parentIndex, structuralIndex) === ''
                      ) {
                        @if (role.get('structuralUnitIds')?.errors?.['invalidStructuralUnits']) {
                          <small class="error-message">
                            {{ 'components.form.errorRequired' | translate }}
                          </small>
                        }
                      }
                    </div>
                  </div>
                  @if ($index > 0) {
                    <div class="actions">
                      <button
                        class="action-link"
                        [policyType]="POLICY_TYPE_ROLE"
                        [claimType]="CLAIM_TYPES['update']"
                        (click)="deleteStructuralUnit(parentIndex, $index)"
                        appPermission>
                        <img src="assets/images/delete-icon.svg" alt="delete" />
                        {{ 'pages.user.deleteAbsence' | translate }}
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        } @else if (roleEntries.at($index).get('roleId')?.value !== getSystemUserId()) {
          <div class="system-role role" [formGroupName]="$index">
            <div class="toggle-left" tabindex="1" aria-controls="collapse">
              @if (hasEditRoleClaim()) {
                <select
                  [ngClass]="{
                    error: shouldRenderError('roles.roleId', parentIndex)
                  }"
                  formControlName="roleId">
                  <option [ngValue]="" [selected]="roleEntries.at($index).get('roleId')?.value === ''" disabled>
                    {{ 'pages.user.chooseRole' | translate }}
                  </option>
                  @for (role of allRoles; track role) {
                    <option
                      [ngValue]="role.id"
                      [selected]="roleEntries.at(parentIndex).get('roleId')?.value === role.id"
                      [disabled]="isRoleOptionDisabled(role.id!)">
                      {{ role.name }}
                    </option>
                  }
                </select>
              } @else {
                <p class="role-text">{{ getRoleName(role.get('roleId')?.value) }}</p>
              }
            </div>
            <div class="actions">
              @if (canEditRole(role.get('roleId')?.value)) {
                <button
                  class="action-link"
                  [policyType]="POLICY_TYPE_ROLE"
                  [claimType]="CLAIM_TYPES['update']"
                  (click)="deleteRole(parentIndex)"
                  appPermission>
                  <img src="assets/images/delete-icon.svg" alt="delete" />
                  {{ 'pages.user.deleteAbsence' | translate }}
                </button>
              }
            </div>
          </div>
        }
      }
    </div>
    }
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading || isSubmitLoading" />
    </div>
  }
  <app-confirm-modal
    [isOpen]="isOpenConfirmBack"
    (confirm)="back(true)"
    (cancel)="onModalClose()"
    title="deleteChanges"
    confirmText="confirm"
    denyText="cancelBack" />
</form>
